import React, {useEffect, useState} from "react";

import {Tabs} from "antd";

import {getProjectId} from "../../helpers";
import {ScopesList} from "../scopes/ScopesList";
import {ArchiveScopesList} from "../scopes/ArchiveScopesList";
import {Archive} from "../../variants"
import {PageTitle} from "../helpers/PageTitle";

const {TabPane} = Tabs;

export function ScopesSettings(props) {
	const [projectId, setProjectId] = useState("");
	const [activeKey, setActiveKey] = useState("1");

	useEffect(() => {
		setProjectId(getProjectId(props.location));
	}, []);

	return (
		<div style={{padding: 10}}>
			<PageTitle title="Scopes" />
			<Tabs activeKey={activeKey} onChange={setActiveKey}>
				<TabPane tab={"Scopes"} key={"1"}>
					<ScopesList activeKey={activeKey} projectId={projectId} />
				</TabPane>
				{Archive.enabled && (
				    <TabPane tab={"Archive"} key={"2"}>
					    <ArchiveScopesList projectId={projectId} activeKey={activeKey} />
				    </TabPane>
				)}
			</Tabs>
		</div>
	);
}
